export default __webpack_public_path__ + "static/moon-7b0c408570add6d1c88dba892b044cad.png";